import React from "react";
import { useLocation } from "react-router-dom";

/**
 * Small notice component shown on /verify-email when no oobCode present.
 * It reads optional email from location.state (redirect from signup).
 */
export default function EmailVerificationNotice() {
  const location = useLocation();
  const email = location && location.state && location.state.email ? location.state.email : null;

  return (
    <div style={{ padding: 16, border: "1px solid #ddd", borderRadius: 6 }}>
      <h3>Verificá tu correo</h3>
      <p>{email ? `Hemos enviado un correo a ${email}.` : "Hemos enviado un correo de verificación a la dirección que ingresaste."}</p>
      <p>Revisá la bandeja de entrada y la carpeta de spam. Hacé clic en el enlace del correo para completar el registro.</p>
      <p>Si no recibiste el correo, volvé a intentar registrarte o inicia sesión y solicita reenviar la verificación.</p>
    </div>
  );
}